const ITEMS = [
  "1.42M REVISIONI VERIFICATE",
  "RCA IN TEMPO REALE",
  "REGISTRO VEICOLI ITALIA",
  "CRONOLOGIA CERTIFICATA",
  "CONTROLLO MANOMISSIONI",
  "PAGAMENTI SICURI STRIPE",
];

export default function Marquee() {
  return (
    <div
      className="relative border-y border-[#ff007f]/20 bg-[#0c0c10]/60 py-3 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1} className="flex items-center">
            {ITEMS.map((it) => (
              <span
                key={it}
                className="flex items-center font-jetmono text-[10px] tracking-[0.3em] text-[#8a8a9e] whitespace-nowrap"
              >
                <span className="text-[#ff007f] mx-6 text-[8px]">◆</span>
                {it}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
